/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  transform 'and' to '&'
 */

export const transformAndToAmpersand = (transformString: string) => {
  return transformString.replace(/\s+and\s+/i, ' & ')
}
